<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#211d70"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="permission_routers"></sidebar-item>
      <el-row class="luxtag-link">
        <img v-on:click="link()" v-if="sidebar.opened" class="logo" src="../../../../assets/logo-powerby-luxtag.png">
      </el-row>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    link() {
      window.open('https://luxtag.io')
    }
  }
}
</script>
<style lang="scss" scoped>
  .scrollbar-wrapper {
    //margin-top: 50px;
    .logo {
      width: 80%;
      object-fit: contain;
      align-self: center;
    }
    .luxtag-link {
      display: flex;
      position: absolute;
      height: 60px;
      bottom: 180px;
      background-color: #211d70;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue